export default {
  meta: {
    title: '加盟商管理' // 加盟商管理-标准版
  }
};
